import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label, Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData, Preview } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import UpdateBloc from './Blocs/UpdateBloc'

import Shimmer from "react-shimmer-effect";
import moment from 'moment'
import DatePicker from '../../../../../helpers/ui/DatePicker'

import InfoComponents from "../Create/Components/InfoComponents"

class UpdateView extends Component {

    source
    indexBloc = new IndexBloc()
    updateBloc = new UpdateBloc()
    timer

    // Array Status Pegawai yang Dapat Cuti Tahunan
    allowed = ['PNS', 'Honorer'];

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_detail = !accessRole('approve') ? (this.userdata != null ? this.userdata : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted : "")

    currentRoleId = JSON.parse(localStorage.getItem('currentRoleId'));

    constructor(props) {
        super(props)
        this.state = {
            detail: {},
            typeOption: [],
            childTypeOption: [],
            signatoriesOption: [],
            selectedType: '',
            kuota: [],
            listCuti: [],
            startDate: null, 
            endDate: null,
            typeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'paid_leave_type_id',
                    order: 'asc' 
                }
            },
            signatoriesFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'signatories_official_id',
                    order: 'asc' 
                }
            },
            minDateLoading: false,
            minDateAwal: "",
            minDateSelesai: "",
            maxDateSelesai: "",
            paid_leave_type_loading: true,
            childTypeLoading: false,
            sisa_cuti: 0,
            quotaList: [],
            holidays: sessionStorage.getItem('holidays') ? JSON.parse(sessionStorage.getItem('holidays')) : []
        }
    }

    getSisaCuti = () => {
        // let sisaCutiTahunIni = 0;
        // if (this.state.kuota) {
        //     let sisaCuti = 0;
        //     sisaCuti = (this.state.kuota?.oneYearBefore > 6 ? 6 : this.state.kuota?.oneYearBefore) + (this.state.kuota?.twoYearBefore > 6 ? 6 : this.state.kuota?.twoYearBefore)
        //     if (sisaCuti > 6) {
        //         sisaCuti = 6
        //     }
        //     sisaCutiTahunIni = this.state.kuota?.yearNow + sisaCuti;
        // }

        // return sisaCutiTahunIni;

        return this.state.sisa_cuti;
    }

    handleTypeCuti = (v) => {
        if (v == 'b490a04a-0362-489b-832a-29e4c3b961bc') { // cuti tahunan
            this.loadMindate({amount: (this.getSisaCuti())})
            // console.log(moment(v, "YYYY-MM-DD").add(sisaCutiTahunIni, 'days').format('YYYY-MM-DD'), sisaCutiTahunIni)
            // this.setState({
            //     minDate: moment(v, "YYYY-MM-DD").add(sisaCutiTahunIni, 'days').format('YYYY-MM-DD')
            // })
        } else {
            // this.setState({
            //     minDate: ""
            // })
            this.loadMindate({amount: (0)})
        }
    }

    handleTanggalCuti = (v) => {
        if (this.state.selectedType == 'b490a04a-0362-489b-832a-29e4c3b961bc') { // cuti tahunan
            this.loadMindate({date: v, amount: (this.getSisaCuti())})
        } else {
            this.loadMindate({amount: (0)})
        }
    }

    loadMindate = (query) => {
        this.setState({
            minDateLoading: true
        });
        this.updateBloc.fetchMinDate(query)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              paid_leave_uuid: this.props.uuid,
              paid_leave_employee_uuid: this.state.employee?.employee_uuid,
              access_id : this.currentRoleId,
              ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'document')
        await this.updateBloc.fetchUpdate(dataForm)
    }

    checkDate = () => {        
        this.updateBloc.fetchCheckDate({
            employee_uuid: this.state.employee?.employee_uuid,
            start_date: this.state.startDate,
            end_date: this.state.endDate
        })
    }

    confirmResponse = (response) => {
        let forState = {}

        if (this.state.selectedType === 'b490a04a-0362-489b-832a-29e4c3b961bc') { 
            let sisaCutiTahunIni = 0;
            if (this.state.kuota) {
                let sisaCuti = 0;
                sisaCuti = (this.state.kuota?.oneYearBefore > 6 ? 6 : this.state.kuota?.oneYearBefore) + (this.state.kuota?.twoYearBefore > 6 ? 6 : this.state.kuota?.twoYearBefore)
                if (sisaCuti > 6) {
                    sisaCuti = 6
                }
                sisaCutiTahunIni = this.state.kuota?.yearNow + sisaCuti;
                sisaCutiTahunIni = sisaCutiTahunIni - this.state.listCuti?.length
                if (sisaCutiTahunIni < 0) {
                    response = 'cancel'
                }
            }
        } 

        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadSignatoriesList = async () => {
        let offset = (this.state.signatoriesFilter.page_number-1)*this.state.signatoriesFilter.page_size
        const query = {
            search: this.state.signatoriesFilter.filter_value,
            limit: this.state.signatoriesFilter.page_size,
            offset: offset,
            order: this.state.signatoriesFilter.sort_order.column,
            sort: this.state.signatoriesFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchSignatoriesList(query, this.source.token)
    }

    loadTypeList = async () => {
        let offset = (this.state.typeFilter.page_number-1)*this.state.typeFilter.page_size
        const query = {
            search: this.state.typeFilter.filter_value,
            limit: this.state.typeFilter.page_size,
            offset: offset,
            order: this.state.typeFilter.sort_order.column,
            sort: this.state.typeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchTypeList(query, this.source.token)
    }

    loadChildTypeList = async () => {
        const query = {
            parent: this.state.selectedType
        }
        this.setState({ childTypeLoading: true, childTypeOption: [] })
        await this.indexBloc.fetchChildTypeList(query, this.source.token)
    }
    
    loadKuota = async () => {
        await this.indexBloc.fetchKuotaTahunan({ uuid: this.state.employee?.employee_uuid })
    }

    loadDetail = async () => {
        const query = { 
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadSignatoriesList()
        this.loadDetail()
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.signatoriesFilter.filter_value = value

        this.timer = setTimeout(() => this.loadSignatoriesList(), 800);
    }

    dateChange = () => {
        const { startDate, endDate, selectedType } = this.state

        if (selectedType === 'b490a04a-0362-489b-832a-29e4c3b961bc') {
            if (startDate != null && endDate != null) {
                let start = new Date(startDate)
                let end = new Date(endDate)
                let list = new Array()

                for (let m = start.getMonth(); m <= end.getMonth(); m++) {
                    for (let d = 1; d <= 31; d++) {
                        let time = `${start.getFullYear()}-${m+1}-${d}`
                        time = new Date(time)

                        if (d < start.getDate() && m == start.getMonth()) {
                            continue
                        }
                        if (m == end.getMonth() && d > end.getDate()) {
                            continue
                        }
                        if (time.getMonth() == m) {
                            if (time.getDay() != 6 && time.getDay() != 0) {
                                let theDate = moment(time).format('YYYY-MM-DD');
                                if (!this.state.holidays.includes(theDate)) {
                                    list.push(theDate);
                                }
                            }
                        }
                    }
                }
                this.setState({ listCuti: list })
                console.log(list, 'list-cuti')
            }
        }
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.kuotaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    if (response) {
                        this.setState({
                            quotaList: response?.list,
                            sisa_cuti: response?.sisa
                        })
                    }
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState(
                        { 
                            detail: result.data.response, 
                            selectedType: result.data.response.paid_leave_type_uuid,
                            startDate: result.data.response?.paid_leave_start_date,
                            enddate: result.data.response?.paid_leave_end_date,
                            listCuti: result.data.response?.details,
                            employee: result.data.response?.employee
                        }
                    )

                    setTimeout(() => {
                        this.loadKuota()
                        this.loadTypeList()
                        this.loadChildTypeList()
                    }, 500);
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let type = result.data.response.result
                    // if (!this.allowed.includes(this.state.employee?.employee_status_name)) {
                    //     type = type.filter(function (el) {
                    //         return el.paid_leave_type_uuid != 'b490a04a-0362-489b-832a-29e4c3b961bc' // CUTI TAHUNAN
                    //     });
                    // }

                    const pppkRestrictedTypes = [
                        '47b76ad9-0ccd-493c-8fb0-57d7aee48a80', // Cuti Alasan Penting
                        '22ba90f5-23c3-4ac1-8bad-e7d1cb7ed490'  // Cuti Besar
                    ];
                    if (this.state.employee?.employee_categories_name_full === 'INTERNAL » PPPK') {
                        type = type.filter(function (el) {
                            return !pppkRestrictedTypes.includes(el.paid_leave_type_uuid)
                        });
                    }

                    this.setState({ 
                        typeOption: type,
                        paid_leave_type_loading: false
                    })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.childTypeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let type = result.data.response.result
                    this.setState({ childTypeOption: type, childTypeLoading: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.signatoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ signatoriesOption: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.minDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ 
                        minDateLoading: false,
                        minDateAwal: result.data.response.min_stdate_mulai, 
                        minDateSelesai: result.data.response.min_stdate_selesai,
                        maxDateSelesai: result.data.response.max_stdate
                    })
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        minDateLoading: false
                    });
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.checkDateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let response = result.data.response;
                    this.setState({ 
                        count_used_date: response.count_used_date,
                        pl_date: response.pl_date, 
                        ot_date: response.ot_date
                    })

                    if (response.count_used_date == 0) {
                        this.submitData()
                    } else {
                        this.setState({
                            failedInfo: result.data.message,
                            loading: false,
                            failed: true,
                        });
                    }
                    break;
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break;
                default:
                    break;
            }
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.startDate !== this.state.startDate) {
            this.dateChange()
        }
        if (prevState.endDate !== this.state.endDate) {
            this.dateChange()
        }
        if (prevState.selectedType !== this.state.selectedType) {
            this.dateChange()
            this.loadChildTypeList()
        }
    }

    componentWillUnmount = () => {
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.typeChannel?.unsubscribe()
        this.indexBloc.signatoriesChannel?.unsubscribe()
        this.indexBloc.kuotaChannel?.unsubscribe()
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.minDateChannel.unsubscribe()
        this.updateBloc.checkDateChannel.unsubscribe()
    }
    

    render() {
        const { detail } = this.state
        let sisaCutiTahunIni = this.state.sisa_cuti;
        // if (this.state.kuota) {
        //     let sisaCuti = 0;
        //     sisaCuti = (this.state.kuota?.oneYearBefore > 6 ? 6 : this.state.kuota?.oneYearBefore) + (this.state.kuota?.twoYearBefore > 6 ? 6 : this.state.kuota?.twoYearBefore)
        //     sisaCutiTahunIni = (12 - this.state.kuota?.yearNow) + sisaCuti;
        //     if (sisaCutiTahunIni > 18) {
        //         sisaCuti = 18;
        //         sisaCutiTahunIni = sisaCuti - (12 - this.state.kuota?.yearNow)
        //     }
        // }
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`/izinpegawai/cuti.html`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Edit Pengajuan Cuti</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Pegawai
                                            </Label>
                                            <Col md="4">
                                                <AvField
                                                    name="paid_leave_employee_name"
                                                    placeholder="Masukkan Pegawai"
                                                    errorMessage="Masukkan Pegawai"
                                                    type="text"
                                                    readOnly={true}
                                                    className="form-control"
                                                    value={this.state.employee?.employee_full_name}
                                                    // validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Jenis Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <Select 
                                                    name="paid_leave_type_uuid"
                                                    errorMessage="Pilih Jenis Cuti"
                                                    options={this.state.typeOption}
                                                    optionLabel="paid_leave_type_name"
                                                    optionValue="paid_leave_type_uuid"
                                                    placeholder="Pilih Jenis Cuti"
                                                    defaultValue={this.state.selectedType}
                                                    onChange={opt => {
                                                        this.setState({ selectedType: opt.paid_leave_type_uuid })
                                                        this.handleTypeCuti(opt.paid_leave_type_uuid)
                                                    }}
                                                    validate={{ required: { value: true } }}
                                                    isLoading={this.state.paid_leave_type_loading}
                                                />
                                            </Col>
                                        </Row>

                                        { this.state.selectedType !== '' && this.state.childTypeOption?.length > 0 ?
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Detail Jenis Cuti <span className="text-danger">*</span>
                                                </Label>
                                                <Col md="3">
                                                    <Select 
                                                        name="paid_leave_type_detail_uuid"
                                                        errorMessage="Pilih Detail Jenis Cuti"
                                                        options={this.state.childTypeOption}
                                                        optionLabel="paid_leave_type_detail_name"
                                                        optionValue="paid_leave_type_detail_uuid"
                                                        placeholder="Pilih Detail Jenis Cuti"
                                                        validate={{ required: { value: true } }}
                                                        defaultValue={detail?.paid_leave_type_detail_uuid}
                                                    />
                                                </Col>
                                            </Row>
                                            :
                                                this.state.childTypeLoading ? 
                                                    <Row className="mb-3">
                                                        <Col md={2}>
                                                            <Shimmer>
                                                                <div style={{ width: "100%", height: 40 }}></div>
                                                            </Shimmer>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Shimmer>
                                                                <div style={{ width: "100%", height: 40 }}></div>
                                                            </Shimmer>
                                                        </Col>
                                                    </Row>
                                                :
                                                    ""
                                        }

                                        {
                                            this.state.selectedType != '' && this.state.selectedType != '9e56930f-4643-4547-a427-ebb6fa3330f1' ?
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Informasi Cuti
                                                </Label>
                                                <Col md={8}>
                                                    <InfoComponents uuid={this.state.selectedType} />
                                                </Col>
                                            </Row>
                                            : ""
                                        }   

                                        { this.state.selectedType === 'b490a04a-0362-489b-832a-29e4c3b961bc' &&
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Informasi Sisa Cuti Tahunan
                                                    </Label>
                                                    <Col md="3">
                                                        <Table>
                                                            <thead>
                                                                <tr>
                                                                    <th>Tahun</th>
                                                                    <th>Digunakan</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    this.state.quotaList?.map((item, key) => {
                                                                        return (
                                                                            <tr>
                                                                                <td>{item.tahun}</td>
                                                                                <td>{item.digunakan}</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                                <tr>
                                                                    <th>Sisa Saldo</th>
                                                                    <td>
                                                                        <b>{sisaCutiTahunIni}</b> dari ({this.state.quotaList.length > 0 ? this.state.quotaList[((this.state.quotaList.length)-1)]?.cuti_tahunan : 0})
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                        }

                                        {/* {this.state.selectedType == '2472b11b-6e1d-4f53-a49c-7c13d6477cb7' &&
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                </Label>
                                                <Col md="3">
                                                    <Select 
                                                        name="paid_leave_category"
                                                        errorMessage="Pilih Rawat Inap/Jalan"
                                                        options={[
                                                            {value: 1, label: 'Rawat Inap'},
                                                            {value: 2, label: 'Rawat Jalan'},
                                                        ]}
                                                        defaultValue={detail?.paid_leave_category}
                                                        isSearchable={false}
                                                        placeholder="Pilih Rawat Inap/Jalan"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>
                                        } */}

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                {
                                                    this.state.childTypeLoading ? 
                                                        <Shimmer>
                                                            <div style={{ width: "100%", height: 40 }}></div>
                                                        </Shimmer>
                                                :
                                                    this.currentRoleId == 1 ? // admin tidak dibatasi
                                                        <DatePicker 
                                                            name="paid_leave_start_date"
                                                            isWeekday={true}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholder="Tanggal Mulai"
                                                            errorMessage="Masukan Tanggal Mulai"
                                                            validate={{ required: { value: true } }}
                                                            onChange={ e => {
                                                                this.setState({ startDate: moment(e).format('YYYY-MM-DD') });
                                                                this.handleTanggalCuti(moment(e).format('YYYY-MM-DD'))
                                                            }}
                                                            defaultValue={detail?.paid_leave_start_date}
                                                        />
                                                    :
                                                        <DatePicker 
                                                            name="paid_leave_start_date"
                                                            isWeekday={true}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholder="Tanggal Mulai"
                                                            errorMessage="Masukan Tanggal Mulai"
                                                            validate={{ required: { value: true } }}
                                                            onChange={ e => {
                                                                this.setState({ startDate: moment(e).format('YYYY-MM-DD') });
                                                                this.handleTanggalCuti(moment(e).format('YYYY-MM-DD'))
                                                            }}
                                                            //minDate={this.state.minDateAwal}
                                                            defaultValue={detail?.paid_leave_start_date}
                                                        />
                                                }
                                                {/* <AvField
                                                    name="paid_leave_start_date"
                                                    placeholder="Tanggal Mulai"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    value={detail?.paid_leave_start_date}
                                                    validate={{ required: { value: true } }}
                                                /> */}
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                {
                                                    this.state.childTypeLoading ? 
                                                        <Shimmer>
                                                            <div style={{ width: "100%", height: 40 }}></div>
                                                        </Shimmer>
                                                :
                                                    this.currentRoleId == 1 ? // admin tidak dibatasi
                                                        <DatePicker 
                                                            name="paid_leave_end_date"
                                                            isWeekday={true}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholder="Tanggal Selesai"
                                                            errorMessage="Masukan Tanggal Selesai"
                                                            validate={{ required: { value: true } }}
                                                            onChange={ e => {
                                                                this.setState({ endDate: moment(e).format('YYYY-MM-DD') });
                                                            }}
                                                            defaultValue={detail?.paid_leave_end_date}
                                                        />
                                                    :
                                                        <DatePicker 
                                                            name="paid_leave_end_date"
                                                            isWeekday={true}
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholder="Tanggal Selesai"
                                                            errorMessage="Masukan Tanggal Selesai"
                                                            validate={{ required: { value: true } }}
                                                            onChange={ e => {
                                                                this.setState({ endDate: moment(e).format('YYYY-MM-DD') });
                                                            }}
                                                            minDate={this.state.minDateSelesai}
                                                            defaultValue={detail?.paid_leave_end_date}
                                                        />
                                                }
                                                {/* <AvField
                                                    name="paid_leave_end_date"
                                                    placeholder="Tanggal Selesai"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    value={detail?.paid_leave_end_date}
                                                    validate={{ required: { value: true } }}
                                                /> */}
                                                { this.state.selectedType === 'b490a04a-0362-489b-832a-29e4c3b961bc' &&
                                                  <span className="text-muted">Jumlah cuti diajukan : <strong>{this.state.listCuti?.length}</strong> Hari (hari libur tidak dihitung)</span>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alasan Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="paid_leave_reason"
                                                    placeholder="Masukkan Alasan Cuti"
                                                    errorMessage="Masukkan Alasan Cuti"
                                                    type="textarea"
                                                    className="form-control"
                                                    value={detail?.paid_leave_reason}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alamat Selama Menjalankan Cuti
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="paid_leave_address"
                                                    placeholder="Masukkan Alamat Selama Menjalankan Cuti"
                                                    errorMessage="Masukkan Alamat Selama Menjalankan Cuti"
                                                    type="textarea"
                                                    value={detail?.paid_leave_address}
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                No Telepon Selama Cuti
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="paid_leave_phone"
                                                    placeholder="Masukkan No Telepon Selama Cuti"
                                                    errorMessage="Masukkan No Telepon Selama Cuti"
                                                    type="text"
                                                    value={detail?.paid_leave_phone}
                                                    className="form-control"
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Atasan <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <AvField
                                                    name="paid_leave_signatories_official"
                                                    placeholder="Masukkan Atasan"
                                                    errorMessage="Masukkan Atasan"
                                                    type="text"
                                                    className="form-control"
                                                    value={detail?.paid_leave_signatories_official}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Dokumen Data Pendukung
                                            </Label>
                                            <Col md="4">
                                                <FileInput 
                                                    col="6"
                                                    name="document"
                                                    value={detail?.document}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Dokumen Data Pendukung Sebelumnya
                                            </Label>
                                            <Label
                                                className="col-md-5 col-form-label"
                                            >
                                                { detail ? 
                                                    <Preview value={detail?.document} />
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="9">
                                                <Link to={`/izinpegawai/cuti.html`}>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/izinpegawai/cuti.html`} />
                : null }



            </Fragment>
        )
    }

}

export default UpdateView